<template>
    <div>
        <v-dialog v-model="isActive" width="460" transition="dialog-bottom-transition">
            <v-card class="rounded-0 pa-5">
                <v-col cols="12" md="12" class="d-flex justify-center pa-0 ma-0">
                    <!--  <v-progress-linear v-if="loading" indeterminate height="5" color="orange"></v-progress-linear> -->
                    <div class="d-flex justify-center text-center">
                        <v-icon v-if="type == 'constancia'" color="orange darken-2"
                            size="130">mdi-alert-circle-outline</v-icon>
                        <v-img v-else :src="getImage()" class="ma-1" width="130px" />
                    </div>
                </v-col>
                <v-col cols="12" md="12" class="d-flex justify-center py-0 px-5">
                    <v-card-text class="font-weight-regular black--text text-h6 d-flex justify-center text-center">
                        {{ mensajeTexto }}
                    </v-card-text>
                </v-col>
                <v-card-actions class="d-flex justify-center align-center ma-1 pa-0">
                    <div class="ma-0 pa-0 d-flex flex-column justify-center align-center text-center">
                        <v-btn @click="goToVista" elevation="0" width="200" color="primary" class="py-5">
                            {{ textoBtn }}
                        </v-btn>
                        <v-btn @click="confirmAndClose(false)" outlined elevation="0" width="200" color="secondary"
                            class="py-5 mt-1 ">
                            cerrar
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import iconFamily from '@/assets/icons/img-datos-familia.png'
export default {

    name: 'DialogoBlockTramite',
    props: {
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isActive: false,
        }
    },
    mounted() {
    },
    methods: {
        getImage() {
            return iconFamily
        },
        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false
        },
        abrirDialogo() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },
        goToVista() {
            this.confirmAndClose(true);
            this.$nextTick(() => {
                this.$router.push(this.url)
            });
        },
    },
    computed: {

        mensajeTexto() {
            if (this.type == 'constancia') {
                return 'No se puede generar la constancia para convenios ya que existen conceptos adeudados'
            } else if (this.type == 'familiares') {
                return 'Para agregar o editar familiares comunicate con tu delegación distrital. Muy pronto vas a poder realizar esta gestión desde aquí.'
            }
        },
        url() {
            if (this.type == 'constancia') {
                return '/boletas'
            } else if (this.type == 'familiares') {
                return '/mediosDeContacto'
            }
        },
        textoBtn() {
            if (this.type == 'constancia') {
                return 'IR A PAGAR'
            } else if (this.type == 'familiares') {
                return 'CONTACTOS'
            }
        }
    },
}

</script>